<template>
  <v-dialog fullscreen persistent v-model="displayed" max-width="1000px">
    <v-card>
      <v-toolbar color="primary">
        <v-card-title class="pl-0">
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
      </v-toolbar>

      <v-card-text style="height: calc(100vh - 108px); overflow: auto">
        <v-tabs
          v-if="editedIndex === -1"
          background-color="#272727"
          v-model="isNewMedia"
          class="mt-5"
        >
          <v-tab class="primary--text" :key="0">
            <v-icon class="mr-2 primary--text text-h6"
              >mdi-file-plus-outline</v-icon
            >
            New Media
          </v-tab>
          <v-tab class="primary--text" :key="1"> Select existing media </v-tab>

          <v-tab-item :key="0">
            <v-container fluid class="pl-0 pr-0">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedItem.name"
                    :hide-details="true"
                    label="Name"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="getMediaTypes"
                    v-model="editedItem.mediaTypeId"
                    label="Media Type"
                    item-text="label"
                    item-value="value"
                    :hide-details="true"
                    :disabled="editedIndex !== -1"
                    @change="resetOrder"
                  ></v-select>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedItem.langId"
                    label="Language ID"
                    :hide-details="true"
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="langOptions"
                    item-text="name"
                    item-value="id"
                    label="Language"
                    outlined
                    v-model="editedItem.langId"
                    :menu-props="{ top: false, offsetY: true }"
                    class="mx-0 mb-3"
                    hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row
                justify="space-around"
                v-if="
                  editedItem.mediaTypeId === enums.MediaType.poi_image ||
                    editedItem.mediaTypeId ===
                      enums.MediaType.project_title_image ||
                    editedItem.mediaTypeId === enums.MediaType.poi_image_dzi ||
                    editedItem.mediaTypeId === enums.MediaType.menu_item_image
                "
              >
                <v-col cols="12" sm="12" md="12">
                  <v-tabs
                    v-if="editedIndex === -1"
                    background-color="#272727"
                    v-model="imageAssetTabActive"
                  >
                    <!-- <v-tabs-slider></v-tabs-slider> -->
                    <v-tab
                      class="primary--text"
                      :key="1"
                      :href="`#image-asset-tab-file`"
                    >
                      <v-icon class="mr-2 primary--text text-h6"
                        >mdi-file-plus-outline</v-icon
                      >
                      File
                    </v-tab>
                    <v-tab
                      class="primary--text"
                      :key="2"
                      :href="`#image-asset-tab-url`"
                    >
                      <v-icon class="mr-2 primary--text text-h6"
                        >mdi-link</v-icon
                      >
                      URL
                    </v-tab>

                    <v-tab-item :key="1" :value="'image-asset-tab-url'">
                      <v-card flat class="mx-auto pt-10">
                        <v-card-actions>
                          <v-text-field
                            v-model="editedItem.url"
                            label="URL"
                            @input="onUrlFieldChange"
                            clearable
                            @click:clear="clearUrl()"
                          ></v-text-field>
                        </v-card-actions>
                        <v-img
                          :src="imageData"
                          max-height="400"
                          contain
                          class="grey darken-4 black--text align-end"
                        ></v-img>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item :key="2" :value="'image-asset-tab-file'">
                      <upload-dialog
                        :showDialog="uploadDialogVisible"
                        @done="uploadDialogOnDone"
                        @cancel="uploadDialogOnCancel"
                      ></upload-dialog>
                      <v-card flat class="mx-auto pt-5 pb-5">
                        <div
                          @drop.prevent="addFile"
                          @dragover.prevent
                          class="drop-area"
                        >
                          <span>Drop a file to upload</span>
                          <span>or</span>
                          <v-btn small @click="upload" class="mr-2">
                            Select a file to upload
                            <v-icon right>mdi-file-plus-outline</v-icon>
                          </v-btn>
                        </div>
                        <v-dialog
                          persistent
                          v-model="dialog"
                          v-if="isDzi"
                          fullscreen
                          hide-overlay
                          transition="dialog-bottom-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              class="mt-3"
                              small
                              dark
                              v-bind="attrs"
                              v-on="on"
                              @click="openPolygonsEditor()"
                            >
                              Edit link areas
                              <v-icon class="ml-1 text-subtitle-1"
                                >mdi-pencil</v-icon
                              >
                            </v-btn>
                          </template>
                          <v-card height="100%">
                            <v-toolbar dark color="primary">
                              <v-btn icon dark @click="dialog = false">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                              <v-toolbar-title>Edit link areas</v-toolbar-title>
                              <v-select
                                v-if="selectedPolygon"
                                :items="poisParentsChildrenRecs"
                                v-model="selectedRecord.id"
                                item-value="id"
                                label="Linked record"
                                dense
                                class="ml-4"
                                hide-details
                                :return-object="true"
                                @change="onChildRecordSelectChange($event)"
                              >
                                <template v-slot:selection="{ item }">
                                  {{ item.name }} - {{ item.type }}
                                </template>
                                <template v-slot:item="{ item }">
                                  {{ item.name }} - {{ item.type }}
                                </template>
                              </v-select>
                              <v-spacer></v-spacer>
                              <v-toolbar-items>
                                <v-btn dark text @click="savePolygons()"
                                  >Save</v-btn
                                >
                              </v-toolbar-items>
                            </v-toolbar>
                            <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
                            <open-sea-dragon-viewer
                              ref="osdViewerRef"
                              :id="'osd-viewer'"
                              :options="{
                                defaultZoomLevel: 1,
                                minZoomLevel: 1,
                                maxZoomLevel: 5,
                                ajaxWithCredentials: false,
                                showNavigator: false,
                                showNavigationControl: false,
                                showReferenceStrip: false,
                                homeFillsViewer: true,
                                constrainDuringPan: true,
                                visibilityRatio: 1,
                                iOSDevice: true,
                                loadTilesWithAjax: true,
                                ajaxWithCredentials: true,
                                //ajaxHeaders: {
                                // Example of using the viewer-level ajaxHeaders option
                                // for providing an authentication token.
                                //  Authorization: 'Bearer ' + token
                                //},
                                animationTime: 0.5,
                                immediateRender: true
                              }"
                              :tile-sources="currentTileSources"
                              :polygonsData="polygonsData"
                              @selected="onSelection"
                              @deselected="onDeselection"
                            />
                          </v-card>
                        </v-dialog>
                        <v-img
                          :src="imageData"
                          max-height="400"
                          contain
                          class="grey darken-4 black--text align-end mt-3"
                        ></v-img>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                  <template
                    v-else-if="imageAssetTabActive === 'image-asset-tab-url'"
                  >
                    <v-card flat class="mx-auto pt-10">
                      <v-card-actions>
                        <v-text-field
                          v-model="editedItem.url"
                          label="URL"
                          @input="onUrlFieldChange"
                          clearable
                          @click:clear="clearUrl()"
                        ></v-text-field>
                      </v-card-actions>
                      <v-img
                        :src="imageData"
                        max-height="400"
                        contain
                        class="grey darken-4 black--text align-end"
                      ></v-img>
                    </v-card>
                  </template>
                  <template v-else>
                    <upload-dialog
                      :showDialog="uploadDialogVisible"
                      @done="uploadDialogOnDone"
                      @cancel="uploadDialogOnCancel"
                    ></upload-dialog>
                    <v-card flat class="mx-auto pt-5 pb-5">
                      <div
                        @drop.prevent="addFile"
                        @dragover.prevent
                        class="drop-area"
                      >
                        <span>Drop a file to upload</span>
                        <span>or</span>
                        <v-btn small @click="upload" class="mr-2">
                          Select a file to upload
                          <v-icon right>mdi-file-plus-outline</v-icon>
                        </v-btn>
                      </div>
                      <v-dialog
                        persistent
                        v-model="dialog"
                        v-if="isDzi"
                        fullscreen
                        hide-overlay
                        transition="dialog-bottom-transition"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            class="mt-3"
                            small
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="openPolygonsEditor()"
                          >
                            Edit link areas
                            <v-icon class="ml-1 text-subtitle-1"
                              >mdi-pencil</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-card height="100%">
                          <v-toolbar dark color="primary">
                            <v-btn icon dark @click="dialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Edit link areas</v-toolbar-title>
                            <v-select
                              v-if="selectedPolygon"
                              :items="poisParentsChildrenRecs"
                              v-model="selectedRecord.id"
                              item-value="id"
                              label="Linked record"
                              dense
                              hide-details
                              class="ml-4"
                              :return-object="true"
                              @change="onChildRecordSelectChange($event)"
                            >
                              <template v-slot:selection="{ item }">
                                {{ item.name }} - {{ item.type }}
                              </template>
                              <template v-slot:item="{ item }">
                                {{ item.name }} - {{ item.type }}
                              </template>
                            </v-select>
                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                              <v-btn dark text @click="savePolygons()"
                                >Save</v-btn
                              >
                            </v-toolbar-items>
                          </v-toolbar>
                          <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
                          <open-sea-dragon-viewer
                            ref="osdViewerRef"
                            :id="'osd-viewer'"
                            :options="{
                              defaultZoomLevel: 1,
                              minZoomLevel: 1,
                              maxZoomLevel: 5,
                              ajaxWithCredentials: false,
                              showNavigator: false,
                              showNavigationControl: false,
                              showReferenceStrip: false,
                              homeFillsViewer: true,
                              constrainDuringPan: true,
                              visibilityRatio: 1,
                              iOSDevice: true,
                              loadTilesWithAjax: true,
                              ajaxWithCredentials: true,
                              //ajaxHeaders: {
                              // Example of using the viewer-level ajaxHeaders option
                              // for providing an authentication token.
                              //  Authorization: 'Bearer ' + token
                              //},
                              animationTime: 0.5,
                              immediateRender: true
                            }"
                            :tile-sources="currentTileSources"
                            :polygonsData="polygonsData"
                            @selected="onSelection"
                            @deselected="onDeselection"
                          />
                        </v-card>
                      </v-dialog>
                      <v-img
                        :src="imageData"
                        max-height="400"
                        contain
                        class="grey darken-4 black--text align-end mt-3"
                      ></v-img>
                    </v-card>
                  </template>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  editedItem.mediaTypeId === enums.MediaType.poi_title ||
                    editedItem.mediaTypeId === enums.MediaType.project_title ||
                    editedItem.mediaTypeId ===
                      enums.MediaType.menu_item_title ||
                    editedItem.mediaTypeId ===
                      enums.MediaType.unity_language_config
                "
              >
                <v-col cols="12" sm="6" md="12">
                  <v-textarea
                    rows="6"
                    outlined
                    v-model="editedItem.textualContent"
                    label="Textual content"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  editedItem.mediaTypeId === enums.MediaType.description ||
                    editedItem.mediaTypeId ===
                      enums.MediaType.project_text_description
                "
              >
                <v-col cols="12" sm="6" md="12">
                  <editor
                    v-model="editedItem.textualContent"
                    :init="{
                      invalid_styles: {
                        table: 'height',
                        tr: 'width height',
                        th: 'width height',
                        td: 'width height'
                      },
                      height: 550,
                      menubar: true,
                      plugins: [
                        'advlist autolink lists link',
                        'searchreplace visualblocks',
                        'insertdatetime table paste code'
                      ],
                      table_default_attributes: {
                        border: '0'
                      },
                      table_default_styles: {
                        width: '100%'
                      },
                      menubar: false,
                      toolbar:
                        'undo redo | table | bold italic backcolor | \
               alignleft aligncenter alignright alignjustify | \
               bullist numlist outdent indent | removeformat | code'
                    }"
                  />
                </v-col>
              </v-row>
              <v-row
                v-if="
                  this.$store.state.PoiStore.poiContext === 'building' &&
                    editedItem.mediaTypeId === enums.MediaType.poi_image_dzi
                "
              >
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="order"
                    :hide-details="true"
                    label="Order"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0" v-if="isSuperAdmin">
                <!--            <v-col cols="12" sm="6" md="3">-->
                <!--              <v-text-field label="Media Data" solo readonly></v-text-field>-->
                <!--            </v-col>-->
                <v-col cols="12" sm="6" md="12">
                  <v-card>
                    <v-card-title>Media Data</v-card-title>
                    <v-jsoneditor
                      v-model="editedItem.mediaData"
                      :plus="true"
                      height="300px"
                      @onChangeText="onJsonEditorChange"
                      :options="{ mode: 'text' }"
                    ></v-jsoneditor>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item :key="1">
            <v-container fluid class="pa-0 ma-0">
              <v-container fluid class="d-flex align-center pr-4 pl-2">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-select
                      class="ma-0 pa-1"
                      :items="getMediaTypes"
                      v-model="editedItem.mediaTypeId"
                      label="Media Type"
                      clearable
                      item-text="label"
                      item-value="value"
                      :hide-details="true"
                      :disabled="editedIndex !== -1"
                      @change="filterMedia(editedItem.mediaTypeId)"
                    ></v-select>
                  </v-col>
                  <v-btn @click="resetFilterMedia()" class="pa-2 mt-3"
                    >Reset Filters</v-btn
                  >
                </v-row>
                <v-spacer></v-spacer>
                <v-text-field
                  :hide-details="true"
                  v-model="searchKeywords"
                  outlined
                  dense
                  label="Search"
                  style="max-width: 200px"
                >
                  <v-icon slot="append">mdi-magnify</v-icon>
                </v-text-field>
              </v-container>
              <div class="pa-4 pt-0">
                <div v-for="m in filteredMedia" :key="m.id" class="mb-2">
                  <media-card-multi
                    :is-grid-view="false"
                    :media="m"
                    :hideActions="true"
                    :checked="isCheckedMedia(m.id)"
                    :showCheckbox="true"
                    @changeChecked="changeChecked(m.id)"
                  ></media-card-multi>
                </div>
                <v-btn
                  @click="loadNextPage()"
                  :disabled="filteredMedia.length === 0"
                  class="pa-2 mt-3"
                  >Load More</v-btn
                >
              </div>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <v-container v-else>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="editedItem.name"
                :hide-details="true"
                label="Name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="getMediaTypes"
                v-model="editedItem.mediaTypeId"
                label="Media Type"
                item-text="label"
                item-value="value"
                :hide-details="true"
                :disabled="editedIndex !== -1"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- <v-text-field
                v-model="editedItem.langId"
                label="Language ID"
                :hide-details="true"
              ></v-text-field> -->
              <v-select
                :items="langOptions"
                item-text="name"
                item-value="id"
                label="Language"
                outlined
                v-model="editedItem.langId"
                :menu-props="{ top: false, offsetY: true }"
                class="mx-0 mb-3"
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            justify="space-around"
            v-if="
              editedItem.mediaTypeId === enums.MediaType.poi_image ||
                editedItem.mediaTypeId ===
                  enums.MediaType.project_title_image ||
                editedItem.mediaTypeId === enums.MediaType.poi_image_dzi ||
                editedItem.mediaTypeId === enums.MediaType.menu_item_image
            "
          >
            <v-col cols="12" sm="12" md="12">
              <template v-if="imageAssetTabActive === 'image-asset-tab-url'">
                <v-card flat class="mx-auto pt-10">
                  <v-card-actions>
                    <v-text-field
                      v-model="editedItem.url"
                      label="URL"
                      @input="onUrlFieldChange"
                      clearable
                      @click:clear="clearUrl()"
                    ></v-text-field>
                  </v-card-actions>
                  <v-img
                    :src="imageData"
                    max-height="400"
                    contain
                    class="grey darken-4 black--text align-end"
                  ></v-img>
                </v-card>
              </template>
              <template v-else>
                <upload-dialog
                  :showDialog="uploadDialogVisible"
                  @done="uploadDialogOnDone"
                  @cancel="uploadDialogOnCancel"
                ></upload-dialog>
                <v-card flat class="mx-auto pt-5 pb-5">
                  <div
                    @drop.prevent="addFile"
                    @dragover.prevent
                    class="drop-area"
                  >
                    <span>Drop a file to upload</span>
                    <span>or</span>
                    <v-btn small @click="upload" class="mr-2">
                      Select a file to upload
                      <v-icon right>mdi-file-plus-outline</v-icon>
                    </v-btn>
                  </div>
                  <v-dialog
                    persistent
                    v-model="dialog"
                    v-if="isDzi"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        class="mt-3"
                        small
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="openPolygonsEditor()"
                      >
                        Edit link areas
                        <v-icon class="ml-1 text-subtitle-1">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <v-card height="100%">
                      <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Edit link areas</v-toolbar-title>
                        <v-select
                          v-if="selectedPolygon"
                          :items="poisParentsChildrenRecs"
                          v-model="selectedRecord.id"
                          item-value="id"
                          label="Linked record"
                          dense
                          hide-details
                          class="ml-4"
                          :return-object="true"
                          @change="onChildRecordSelectChange($event)"
                        >
                          <template v-slot:selection="{ item }">
                            {{ item.name }} - {{ item.type }}
                          </template>
                          <template v-slot:item="{ item }">
                            {{ item.name }} - {{ item.type }}
                          </template>
                        </v-select>
                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                          <v-btn dark text @click="savePolygons()">Save</v-btn>
                        </v-toolbar-items>
                      </v-toolbar>
                      <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
                      <open-sea-dragon-viewer
                        ref="osdViewerRef"
                        :id="'osd-viewer'"
                        :options="{
                          defaultZoomLevel: 1,
                          minZoomLevel: 1,
                          maxZoomLevel: 5,
                          ajaxWithCredentials: false,
                          showNavigator: false,
                          showNavigationControl: false,
                          showReferenceStrip: false,
                          homeFillsViewer: true,
                          constrainDuringPan: true,
                          visibilityRatio: 1,
                          iOSDevice: true,
                          loadTilesWithAjax: true,
                          ajaxWithCredentials: true,
                          //ajaxHeaders: {
                          // Example of using the viewer-level ajaxHeaders option
                          // for providing an authentication token.
                          //  Authorization: 'Bearer ' + token
                          //},
                          animationTime: 0.5,
                          immediateRender: true
                        }"
                        :tile-sources="currentTileSources"
                        :polygonsData="polygonsData"
                        @selected="onSelection"
                        @deselected="onDeselection"
                      />
                    </v-card>
                  </v-dialog>
                  <v-img
                    :src="imageData"
                    max-height="400"
                    contain
                    class="grey darken-4 black--text align-end mt-3"
                  ></v-img>
                </v-card>
              </template>
            </v-col>
          </v-row>
          <v-row
            v-if="
              editedItem.mediaTypeId === enums.MediaType.poi_title ||
                editedItem.mediaTypeId === enums.MediaType.project_title ||
                editedItem.mediaTypeId === enums.MediaType.menu_item_title ||
                editedItem.mediaTypeId === enums.MediaType.unity_language_config
            "
          >
            <v-col cols="12" sm="6" md="12">
              <v-textarea
                rows="6"
                outlined
                v-model="editedItem.textualContent"
                label="Textual content"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row
            v-if="
              editedItem.mediaTypeId === enums.MediaType.description ||
                editedItem.mediaTypeId ===
                  enums.MediaType.project_text_description
            "
          >
            <v-col cols="12" sm="6" md="12">
              <editor
                v-model="editedItem.textualContent"
                :init="{
                  invalid_styles: {
                    table: 'height',
                    tr: 'width height',
                    th: 'width height',
                    td: 'width height'
                  },
                  height: 550,
                  menubar: true,
                  plugins: [
                    'advlist autolink lists link',
                    'searchreplace visualblocks',
                    'insertdatetime table paste code'
                  ],
                  table_default_attributes: {
                    border: '0'
                  },
                  table_default_styles: {
                    width: '100%'
                  },
                  menubar: false,
                  toolbar:
                    'undo redo | table | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code'
                }"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="
              this.$store.state.PoiStore.poiContext === 'building' &&
                editedItem.mediaTypeId === enums.MediaType.poi_image_dzi
            "
          >
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="editedItem.mediaData.order"
                :hide-details="true"
                label="Order"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0" v-if="isSuperAdmin">
            <!--            <v-col cols="12" sm="6" md="3">-->
            <!--              <v-text-field label="Media Data" solo readonly></v-text-field>-->
            <!--            </v-col>-->
            <v-col cols="12" sm="6" md="12">
              <v-card>
                <v-card-title>Media Data</v-card-title>
                <v-jsoneditor
                  v-model="editedItem.mediaData"
                  :plus="true"
                  height="300px"
                  @onChangeText="onJsonEditorChange"
                  :options="{ mode: 'text' }"
                ></v-jsoneditor>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="editedIndex !== -1"
          color="#FF5252"
          small
          @click="deleteMedia"
          >Delete</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="darken-1" small @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" small @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MediaCardMulti from '../components/MediaCards/MediaCardMulti'
//import UploadDialog from '../components/UploadDialog'
import VJsoneditor from 'v-jsoneditor/src/index'
import Enums from '../helpers/Enums'
import { FilesGetMixin } from '../mixins/FilesGetMixin'
import UploadDialog from './UploadDialog'
import OpenSeadragonMixin from '../mixins/OpenSeadragonMixin'
import OpenSeaDragonViewer from '../components/Polygons/OpenSeadragonViewer'
import Editor from '@tinymce/tinymce-vue'
import { sleep } from '../../utils.js'

export default {
  mixins: [FilesGetMixin, OpenSeadragonMixin],
  components: {
    UploadDialog,
    VJsoneditor,
    'open-sea-dragon-viewer': OpenSeaDragonViewer,
    editor: Editor,
    MediaCardMulti
  },
  computed: {
    langOptions() {
      let arr = []
      Object.entries(Enums.lang).forEach(([key, value]) => {
        if (this.projectLangs.includes(value.id)) {
          arr.push(value)
        }
      })
      return arr
    },
    projectLangs() {
      if (this.$store.state.ProjectStore.projectConfig) {
        return this.$store.state.ProjectStore.projectConfig[
          this.$store.state.ProjectStore.projectConfig.length - 1
        ].mediaData.selectedLangs
      }
      return null
    },
    isCheckedMedia() {
      return id => {
        return this.checkedMedia.includes(id)
      }
    },
    isMediaSelected() {
      return id => {
        return this.selectedMedia === id
      }
    },
    isSuperAdmin() {
      return this.$store.state.UserStore.userRole[0] === 'super_admin'
    },
    getMediaTypes() {
      let arr = []
      for (var i = 0; i < this.$store.state.MediaStore.mediaTypes.length; i++) {
        let obj = {
          value: this.$store.state.MediaStore.mediaTypes[i].typeId,
          label: this.$t(
            'mediaTypes.' + this.$store.state.MediaStore.mediaTypes[i].name
          )
        }
        arr.push(obj)
      }
      if (this.$store.state.PoiStore.poiContext === 'apartment') {
        arr = arr.filter(el => el.value !== Enums.MediaType.poi_image_dzi)
      }
      return arr
    },
    formTitle() {
      return this.editedIndex === -1 ? 'Add Media Item ' : 'Edit Media Item'
    },
    imageAssetTabActive: {
      get: function() {
        let retVal = 'image-asset-tab-url'
        if (this.mediaAssetType === Enums.MediaAssetType.image_path) {
          retVal = 'image-asset-tab-file'
        }
        // if (this.editedItem.path && this.editedItem.path !== '') {
        //   retVal = 'image-asset-tab-file'
        // }
        console.log('editedItem', this.editedItem, retVal)
        return retVal
      },
      set: function(newVal) {
        this.changeMediaAssetType(newVal)
      }
    },
    currentFile: {
      get: function() {
        return new File([this.editedItem.path], this.editedItem.path, [
          {
            type: `text/${this.editedItem.path.substring(
              this.editedItem.path.lastIndexOf('.') + 1,
              this.editedItem.path.length
            )}`
          }
        ])
      },
      set: function(newValue) {
        console.log(newValue)
      }
    }
    // imageData: {
    //   get: function() {
    //     let retVal = ''
    //     this.getImage(this.editedItem).then(r => {
    //       retVal = r
    //     })
    //     return retVal
    //   }
    // }
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    editedItem: {
      type: Object,
      required: true,
      default: function() {
        return {
          name: 'New Media Item',
          mediaTypeId: 0,
          textualContent: '',
          mediaData: '',
          path: '',
          url: '',
          parentGalleryId: 0,
          poiId: 0,
          langId: 1
        }
      }
    },
    editedIndex: {
      type: Number,
      required: false,
      default: -1
    },
    poisParentsChildrenRecs: {
      type: Array,
      required: false
    }
  },

  created: async function() {
    this.displayed = this.showDialog
    this.$store.dispatch(
      'ProjectStore/getSelectedProjectSettings',
      this.$store.state.ProjectStore.selectedProject.id
    )
    this.getData()
    this.mediaTypesEnum = Enums.MediaType
  },
  data() {
    return {
      searchParams: {
        langId: 0,
        search: null,
        mediaTypeId: null,
        orderBy: 'updatedAt',
        orderDirection: 'desc'
      },
      selectedMedia: null,
      mediaPerType: [],
      allMedia: [],
      filteredMedia: [],
      pageNumber: 2,
      mediaFilterSelected: false,
      order: null,
      isNewMedia: 0,
      searchKeywords: '',
      fileTypes: ['all', 'audio', 'video', 'image', 'data', 'text', 'gallery'],
      defaultItem: {
        name: 'New Media Item',
        mediaTypeId: 0,
        textualContent: '',
        mediaData: '',
        path: '',
        url: '',
        parentGalleryId: 0,
        poiId: 0,
        langId: 1
      },
      displayed: true,
      text: 'hello!',
      tabs: 2,
      tab: null,
      enums: Enums,
      imageAssetTab: 'image-asset-tab-file',
      imageData: '',
      uploadDialogVisible: false,
      mediaAssetType: Enums.MediaAssetType.image_path,
      isDzi: false,
      currentTileSources: null,
      dialog: false,
      token: null,
      selectedRecord: null,
      selectedPolygon: null,
      polygonsData: null,
      checkedMedia: []
    }
  },

  watch: {
    searchKeywords: function(val) {
      if (this.searchTimer !== null) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(async () => {
        this.infiniteScrollDummyVisible = false
        await this.$store.dispatch('MediaManagerStore/resetMedia')
        await this.$store.dispatch('MediaManagerStore/resetPaging')
        this.searchParams = Object.assign({}, this.searchParams, {
          search: val
        })
      }, 200) // 1 sec delay
    },
    showDialog(newValue) {
      this.imageData = ''
      this.displayed = newValue
      this.selectedMedia = null
      this.checkedMedia = []
      this.isNewMedia = 0
    },
    editedItem: function(newMedia, oldVal) {
      this.refreshEditor(newMedia)

      console.log('watch.editedItem', newMedia, this.mediaAssetType)

      this.mediaAssetType = Enums.MediaAssetType.image_path
      if (newMedia.path && newMedia.path !== '') {
        this.mediaAssetType = Enums.MediaAssetType.image_path
      } else if (newMedia.url && newMedia.url !== '') {
        this.mediaAssetType = Enums.MediaAssetType.image_url
      }

      this.refreshImage(newMedia)

      this.isDzi = this.isMediaDzi(this.editedItem)

      console.log('media item: ', this.editedItem)

      console.log('is dzi ', this.isDzi)

      if (this.isDzi) {
        this.currentTileSources = this.getOsdTileSources([this.editedItem])
        this.token = localStorage.apiCredentials
      }
    }
  },
  methods: {
    async refreshEditor(newMedia) {
      if (
        (newMedia.mediaTypeId === this.enums.MediaType.description ||
          newMedia.mediaTypeId ===
            this.enums.MediaType.project_text_description) &&
        this.isNewMedia === 0
      ) {
        const mediaType =
          newMedia.mediaTypeId === this.enums.MediaType.description
            ? this.enums.MediaType.description
            : this.enums.MediaType.project_text_description
        newMedia.mediaTypeId = null
        await sleep(300)
        newMedia.mediaTypeId = mediaType
      }
    },
    resetOrder() {
      if (this.order) {
        this.order = null
      }
    },
    filterMedia(mediaTypeId) {
      if (mediaTypeId === null) {
        this.resetFilterMedia()
      }
      this.mediaPerType = this.allMedia.filter(
        e => e.mediaTypeId === mediaTypeId
      )
      this.filteredMedia = this.mediaPerType.slice(0, 20 * this.pageNumber)
      this.mediaFilterSelected = true
    },
    resetFilterMedia() {
      this.allMedia = []
      this.pageNumber = 2
      this.getData()
    },
    loadNextPage() {
      if (this.mediaFilterSelected) {
        this.filteredMedia = this.mediaPerType.slice(0, 20 * this.pageNumber)
      } else {
        this.filteredMedia = this.allMedia.slice(0, 20 * this.pageNumber)
      }
      this.pageNumber++
    },
    async getData() {
      let data = []
      data = await this.$store.dispatch(
        'MediaManagerStore/fetchAllMedia',
        this.searchParams
      )
      this.allMedia.push(...data.data)
      this.filteredMedia = this.allMedia.slice(0, 20 * this.pageNumber)
    },
    setSelectedMedia(id) {
      console.log('asd')
      if (this.selectedMedia !== id) {
        this.selectedMedia = id
      } else {
        this.selectedMedia = null
      }
    },
    changeChecked(id) {
      if (this.checkedMedia.includes(id)) {
        for (var i = 0; i < this.checkedMedia.length; i++) {
          if (this.checkedMedia[i] === id) {
            this.checkedMedia.splice(i, 1)
          }
        }
      } else if (!this.checkedMedia.includes(id)) {
        this.checkedMedia.push(id)
      }
    },
    clearUrl() {
      setTimeout(() => {
        this.editedItem.url = ''
      }, 1)
    },
    async deleteMedia() {
      await this.$confirm({
        title: 'Confirm delete',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
      await this.$store.dispatch('MediaStore/deleteMedia', this.editedItem.id)
      this.close()
    },
    addFile(files) {
      let fileList = files.dataTransfer.files
      if (
        fileList === null ||
        typeof fileList === 'undefined' ||
        !fileList.length
      ) {
        return
      }
      const formData = new FormData()
      for (let i = 0; i < fileList.length; i++) {
        formData.append(`file${i}`, fileList[i], fileList[i].name)
      }
      this.$store
        .dispatch('MediaStore/uploadFiles', {
          files: formData
        })
        .then(res => {
          console.log(res)
          this.uploadDialogOnDone(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    close() {
      this.displayed = false
      this.$emit('close')
      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem)
      //   this.editedIndex = -1
      // }, 300)
    },
    async save() {
      if (this.isNewMedia === 1) {
        if (this.checkedMedia.length > 0) {
          let arr = this.$store.state.MediaManagerStore.media.filter(m =>
            this.checkedMedia.includes(m.id)
          )
          if (this.$store.state.PoiStore.selectedPoi) {
            for (let i = 0; i < arr.length; i++) {
              arr[i].poiId = this.$store.state.PoiStore.selectedPoi.id
            }
          }
          await this.$store.dispatch('MediaManagerStore/linkMedia', arr)
          this.close()
        }
        return
      }

      if (this.mediaAssetType === Enums.MediaAssetType.image_url) {
        this.editedItem.path = ''
      } else {
        this.editedItem.url = ''
      }

      if (this.editedIndex > -1) {
        let res = await this.$store.dispatch(
          'MediaStore/updateMedia',
          this.editedItem
        )
        let searchParams = {
          langId: 0,
          search: null,
          mediaTypeId: 2
        }
      } else {
        this.editedItem.order = this.order
        let res = await this.$store.dispatch(
          'MediaStore/createMedia',
          this.editedItem
        )
        // let searchParams = {
        //   langId: 0,
        //   search: null,
        //   mediaTypeId: 2
        // }
        // await this.$store.dispatch('MediaManagerStore/fetchMedia', searchParams)
        // if (this.$store.state.MediaStore.selectedGallery !== null) {
        //   await this.$store.dispatch(
        //     'MediaStore/setSelectedMediaItem',
        //     res.data.id
        //   )
        //   await this.$store.dispatch('MediaStore/addToGallery', {
        //     galleryId: this.$store.state.MediaStore.selectedGallery.id,
        //     mediaIds: [res.data.id]
        //   })
        // }
      }
      //this.$store.dispatch('MediaStore/fetchMedia')
      this.close()
    },
    upload() {
      console.log('upload')
      this.uploadDialogVisible = true
    },
    onJsonEditorChange(newJson) {
      console.log(newJson)
      //this.editedItem.mediaData = newJson
    },
    uploadDialogOnDone(newValue) {
      this.uploadDialogVisible = false
      if (
        newValue.data &&
        Array.isArray(newValue.data) &&
        newValue.data.length > 0
      ) {
        if (newValue.data.length > 1) {
          console.warn('Uploaded more than one file, not implemented yet :-(')
        }
        this.editedItem.name = newValue.data[0].name
        this.editedItem.path = newValue.data[0].tempName
        this.getUpload(this.editedItem.path).then(r => {
          this.imageData = r
        })
      }
    },
    uploadDialogOnCancel() {
      this.uploadDialogVisible = false
    },
    changeMediaAssetType(newVal) {
      console.log('changeMediaAssetType', newVal)
      if (newVal === 'image-asset-tab-url') {
        this.mediaAssetType = Enums.MediaAssetType.image_url
      } else if (newVal === 'image-asset-tab-file') {
        this.mediaAssetType = Enums.MediaAssetType.image_path
      }
      this.refreshImage(this.editedItem)
    },
    refreshImage(newMedia) {
      console.log('refreshImage', this.mediaAssetType)
      if (
        this.mediaAssetType === Enums.MediaAssetType.image_path &&
        newMedia.path
      ) {
        this.getFile(newMedia).then(r => {
          if (
            [
              Enums.MediaType.menu_item_image,
              Enums.MediaType.project_title_image,
              Enums.MediaType.poi_image,
              Enums.MediaType.poi_image_dzi
            ].includes(newMedia.mediaTypeId)
          ) {
            this.imageData = r
          }
        })
      } else {
        this.imageData = ''
      }
      if (
        this.mediaAssetType === Enums.MediaAssetType.image_url &&
        newMedia.url
      ) {
        this.imageData = newMedia.url
      } else {
        this.imageData = ''
      }
    },
    onUrlFieldChange(newValue) {
      console.log('asd', this.editedItem.url)
      this.refreshImage(this.editedItem)
    },
    openPolygonsEditor() {
      let self = this
      this.dialog = true
      // HACK - to make sure refs are instantiated
      //
      if (
        Object.prototype.hasOwnProperty.call(
          self.editedItem.mediaData,
          'polygons'
        )
      ) {
        // self.$refs['osdViewerRef'].importFromJSON(
        //   self.editedItem.mediaData['polygons']
        // )
        self.polygonsData = self.editedItem.mediaData['polygons']
      } else {
        self.polygonsData = []
      }
    },
    savePolygons() {
      console.log('REF: ', this.$refs['osdViewerRef'])
      let data = this.$refs['osdViewerRef'].exportToJSON()
      if (this.editedItem.mediaData['polygons'] !== undefined) {
        this.editedItem.mediaData['polygons'] = data
      } else {
        this.editedItem.mediaData = Object.assign(this.editedItem.mediaData, {
          polygons: data
        })
      }
      this.dialog = false
      console.log('project saved! ', data)
    },
    onSelection(value) {
      console.log('SELECTED: ', value)
      this.selectedPolygon = value
      this.selectedRecord = value.data.linkedRecord
    },
    onDeselection() {
      console.log('DESELECTED.')
      this.selectedPolygon = null
    },
    onChildRecordSelectChange(selectedItem) {
      let self = this
      this.selectedRecord = selectedItem
      this.selectedPolygon.data.linkedRecord = {
        id: self.selectedRecord.id,
        type: self.selectedRecord.type
      }
      //this.selectedRecord.linked = true
    }
  },
  beforeMount: async function() {
    await this.$store.dispatch('MediaManagerStore/resetMedia')
    await this.$store.dispatch('MediaManagerStore/resetPaging')
  },
  beforeDestroy: async function() {
    await this.$store.dispatch('MediaManagerStore/resetMedia')
    await this.$store.dispatch('MediaManagerStore/resetPaging')
  }
}
</script>
<style media="screen">
.drop-area {
  width: 100%;
  border: 4px dashed #ffffff;
  box-sizing: border-box;
  margin-top: 20px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
